'use strict';
angular.module('resCenterVideoRouterModule', []).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider.state('front.networksource.classifiedresource.video.resource', {
            url: '/resource?typename&mediaId&hybaseId&medianame',
            views: {
                'networksource@front.networksource.classifiedresource.video': {
                    templateUrl: './networkResource/classifiedResource/video/video_main_tpl.html',
                    controller: 'resCenVideoCtrl',
                },
            },
        });
    },
]);
